import { PrintLayout } from "../configurations/commonPrint/hooks/usePrintConfig";
import { BlockingRulesData, CreditLimitData, ReminderData, WhatsAppData } from "../configurations/creditControl/types";
import { DateFormat, TimeFormat } from "../configurations/types/configuration.types";

export const toBoolean = (value: any) => value === true || value === "true";

// ── All your existing interfaces (unchanged) ──────────────────────────────────
export interface UserDetailsResponse {
    user_details: UserDetails;
}
export interface UserDetails {
    addresses: Address;
    businessLocation: string;
    businessType: string;
    createdOn: string;
    dob: string;
    emails: { email: string; isPrimary: boolean }[];
    firstName: string;
    middleName?: string;
    lastName: string;
    orgArabicName?: string;
    orgId: string;
    orgName: string;
    phones: { phone: string; isPrimary: boolean }[];
    profileImageUrl: string | null;
    businessLogo: string;
    role: string[];
    status: "Active" | "Inactive" | string;
    themes: ThemeSettings;
    userName: string;
    companyLogo: string | null;
    printProductLimit?: string;
    companyLogoAPP?: string | null;
    permissions: any[];

    userId: string[];
    timeZone: string;
}
export interface Address {
    addressLine1: string;
    addressLine2?: string;
    country: string;
    postalCode: string;
    state: string;
}
export interface ThemeSettings {
    backgroundColour: string;
    fontColour: string;
    fontFamily: string;
}
export interface Configration {
    printType: "print:2" | "print:1" | "print:3";
    tableDefaultSize: number;
    copyQty: number;
    billResetPeriod?: string;
    billNoEnabled: boolean;
    foodTypes?: string[];
    shiftTypes?: string[];
    termsAndConditionsEnglish?: string;
    termsAndConditionsArabic?: string;
    enableTermsAndConditions?: boolean;
    contactQrCode: string;
    locationQrCode: string;
    isProductsNotesEnabled: boolean;
    isDefaultTabsEnabled: boolean;
    deliveryFeeEnabled?: boolean;
    productEditEnabled?: boolean;
    parcelFeeEnabled?: boolean;
    tipsEnabled?: boolean;
    cardPayment?: boolean;
    businessOperationEnable?: boolean;
    businessOperationType?: "Day" | "Shift";
    pdfProductLimit?: string;
    showOutstandingInPdf?: boolean;
    customBusinessName?: string;
    printProductLimit?: string;
    orderTableType?: "Table Type:1" | "Table Type:2";
    appPrinter?: boolean;
    contact_qr_codeAWS?: string;
    location_qr_codeAWS?: string;
    appPrinterEnabled?: boolean | string;
    orderIdEnabled: boolean;
    clientIdEnabled: boolean;
    layoutId?: string;
    printLayoutId?: string;
    customEnabledPrint?: boolean;
    dateFormat?: DateFormat;
    timeFormat?: TimeFormat;
    orderEditingEnabled?: boolean;
    creditControlEnabled?: boolean;
    autoReportGenerationEnabled?: boolean;
}
export interface SubscriptionInfo {
    expiry_date?: string;
    grace_end_date?: string;
    message?: string;
    status: "active" | "inactive" | "expired" | "grace_period" | "blocked";
    warning?: string | null;
    daysRemaining?: number;
}

export interface UserContextProps {
    user: UserDetails | null;
    setUser: (user: UserDetails | null) => void;
    userConfigration: Configration;
    setConfigurations: (config: Configration) => void;
    subscriptionInfo: SubscriptionInfo | null;
    setSubscriptionInfo: (info: SubscriptionInfo | null) => void;
    printConfig: PrintLayout | undefined;
    creditLimit: CreditLimitData;
    blockingRules: BlockingRulesData;
    whatsapp: WhatsAppData;
    reminder: ReminderData;
    setReminder: (reminder: ReminderData) => void;
    setWhatsapp: (whatsapp: WhatsAppData) => void;
    setCreditLimit: (creditLimit: CreditLimitData) => void;
    setBlockingRules: (blockingRules: BlockingRulesData) => void;
    /** NEW — call this to force-refresh all derived context state */
    refreshUserContext: () => void;
}

export const defaultUserContextProps: Configration = {
    printType: "print:1",
    tableDefaultSize: 10,
    copyQty: 1,
    billResetPeriod: "noreset",
    billNoEnabled: false,
    foodTypes: ["Veg", "Non-Veg"],
    contactQrCode: "",
    locationQrCode: "",
    termsAndConditionsEnglish: "",
    termsAndConditionsArabic: "",
    enableTermsAndConditions: false,
    isDefaultTabsEnabled: false,
    isProductsNotesEnabled: false,
    deliveryFeeEnabled: false,
    parcelFeeEnabled: false,
    tipsEnabled: false,
    printProductLimit: "5",
    customBusinessName: "Grocery",
    orderTableType: "Table Type:1",
    contact_qr_codeAWS: "",
    location_qr_codeAWS: "",
    appPrinterEnabled: false,
    orderIdEnabled: true,
    clientIdEnabled: false,
    customEnabledPrint: false,
    printLayoutId: "",
    cardPayment: false,
    dateFormat: "DD/MM/YYYY",
    timeFormat: "12h",
    autoReportGenerationEnabled: false
};
